import { render, staticRenderFns } from "./DealViewer.vue?vue&type=template&id=0c7f2513&scoped=true"
import script from "./DealViewer.vue?vue&type=script&lang=js"
export * from "./DealViewer.vue?vue&type=script&lang=js"
import style0 from "./DealViewer.vue?vue&type=style&index=0&id=0c7f2513&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f2513",
  null
  
)

export default component.exports